import { useEffect } from 'react'

import {
  selectCurrentVariantCohort,
  selectGrowthBookExperiments,
} from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { useBulkSelector } from 'hooks/common/useBulkSelector'

import { eventLogger } from 'services/eventLogger.service'

import { Cohort } from 'root-constants/common'

type TABConfig = Record<
  string,
  {
    utm: { name: string; value: string }
    variation: string
    experimentKey: string
  }
>
const config: TABConfig = {
  [Cohort.GOOGLE_9]: {
    utm: {
      name: 'utm_campaign',
      value: 'Famio_Web_CPA_WW_ENG_Search_Broad_24.02.26',
    },
    variation: '0',
    experimentKey: 'abtest_car_2015_old_vs_next',
  },
  [Cohort.FAMYLOCATE_V1]: {
    utm: {
      name: 'utm_campaign',
      value: 'FamyLocate_Web_WW_ES_CPA_Search_Broad_24.10.24',
    },
    variation: '0',
    experimentKey: 'abtest_car_2016_vert_vs_hor_es',
  },
}

const useSelectors = () =>
  useBulkSelector({
    uuid: selectUUID,
    growthBookExperiments: selectGrowthBookExperiments,
    cohort: selectCurrentVariantCohort,
  })

export const useSendABSegment = (): void => {
  const { uuid, growthBookExperiments, cohort } = useSelectors()

  useEffect(() => {
    if (!uuid || !cohort) return

    const cohortConfig = config[cohort]
    if (!cohortConfig) return

    if (!growthBookExperiments?.[cohortConfig.experimentKey]) return

    const URLParams = new URLSearchParams(window.location.search)
    const utmTagsFromUrl = Object.fromEntries(URLParams.entries())
    const utmConfig = cohortConfig.utm

    if (utmTagsFromUrl[utmConfig.name] !== utmConfig.value) return

    const segmentName =
      growthBookExperiments[cohortConfig.experimentKey][cohortConfig.variation]

    eventLogger.logGrowthbookAbSegmentName({
      experimentKey: cohortConfig.experimentKey,
      variantId: cohortConfig.variation,
      variantName: segmentName,
    })
  }, [uuid, cohort, growthBookExperiments])
}
